<template>
  <div
    class="avatar"
    :class="avatarClass"
    :style="{ width: sizeUnit, height: sizeUnit }"
    @click.stop="child"
  >
    <span
      v-if="status"
      class="status"
      :class="getClassByStatus(currentState)"
      :style="{
        width: statusSize,
        height: statusSize,
        border: `${borderSize} solid #fff`
      }"
    ></span>
    <img :src="imgSrc" @error="imgError" />
  </div>
</template>

<script>
export default {
  name: "avatar",
  data() {
    return {
      defult_img: require("../../src/assets/imgs/server-avatar.jpg")
    };
  },
  props: {
    size: {
      type: Number,
      default: 36
    },
    src: {
      type: [String, Number],
      default: () => {
        return _.random(0, 100);
      }
    },
    border: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default: false
    },
    currentState: {
      type: String,
      default: "1"
    },
    imgSrc: {
      type: String,
      default: ""
    }
  },
  computed: {
    avatarClass() {
      let _class = [];
      if (this.border) {
        _class.push("border");
      }
      return _class;
    },
    borderSize() {
      return _.toNumber(this.size) * 0.035 + "px";
    },
    statusSize() {
      return _.toNumber(this.size) * 0.272727273 + "px";
    },
    sizeUnit() {
      return _.isNumber(this.size) ? `${this.size}px` : this.size;
    }
  },
  methods: {
    child() {
      console.log("防止点击元素刷新channelId!");
    },
    imgError() {
      console.log("头部头像加载失败");
      this.$store.commit("setState", {
        serverAvatar: this.defult_img
      });
    },
    getClassByStatus(num = "1") {
      switch (num) {
        case "1":
          return "online";
        case "0":
          return "leave";
        case "2":
          return "busy";
        default:
          return "online";
      }
    }
  }
};
</script>

<style scoped lang="less">
.avatar {
  background-color: #bcbcbc;
  border-radius: 50%;
  position: relative;

  &.border {
    border: 1px solid #fff;
  }

  .status {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 8px;
    height: 8px;
    background-color: #4eda0e;
    border-radius: 50%;
    z-index: 1;
    &.online {
      background-color: #4eda0e;
    }
    &.leave {
      background: #ff9416;
      &::before,
      &::after {
        content: "";
        width: 1px;
        height: 3px;
        position: absolute;
        background: #fff;
        border-radius: 10px;
        left: 50%;
        top: 50%;
      }
      &::before {
        border-radius: 10px;
        margin-left: -2px;
        margin-top: -2px;
        height: 3.5px;
      }
      &::after {
        transform: rotate(-90deg);
      }
    }
    &.busy {
      background: #ff4a3f;
      &::before {
        content: "";
        position: absolute;
        width: 4px;
        height: 1px;
        border-radius: 10px;
        left: 50%;
        top: 50%;
        background: #fff;
        margin: -1px 0 0 -2px;
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
